import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={32}
    height={6}
    fill="none"
    {...props}
  >
    <Path
      stroke="#000"
      strokeWidth={0.5}
      d="m1 5 3.586-3.586a2 2 0 0 1 2.828 0l2.172 2.172a2 2 0 0 0 2.828 0l2.172-2.172a2 2 0 0 1 2.828 0l2.172 2.172a2 2 0 0 0 2.828 0l2.172-2.172a2 2 0 0 1 2.828 0L31 5"
      opacity={0.3}
    />
  </Svg>
)
export default SvgComponent
